import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import WorksheetActionBySection from '../WorksheetActionBySection';

const WorksheetTestedBySection = () => (
  <NamePrefixModifier namePrefix="header">
    <WorksheetActionBySection
      actionBy="TestedBy"
      actionDate="TestedDate"
      clearActionTitle="Clear"
      setActionTitle="Set Tester and Date"
      actionByLabel="Tested By"
      actionDateLabel="Date Tested"
      actionHeading="Testing Details"
    />
  </NamePrefixModifier>
);

export { WorksheetTestedBySection };
export default WorksheetTestedBySection;
